import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import MassNotification from '../../models/MassNotification'

export interface MassNotificationListState extends PaginatedApiState {
  massNotifications?: MassNotification[]
}

const MassNotificationList = (state: MassNotificationListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<MassNotificationListState>('MASS_NOTIFICATION_LIST')(state, action)
  }
}

export default MassNotificationList
